import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import { Pagination, styled } from '@mui/material';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Image from 'next/image';
import { useRouter } from 'next/router';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { API } from '_helpers';
import { useTypedSelector } from '../../hooks';
import { cleanGallery, loadImages, showImage } from '../../store';
import GalleryImage from '../galleryImage';

interface IProps {
  data: IGallery[];
  page: number;
  count: number;
  categories: ICategory[];
  path: string;
}

const ImagesList: React.FC<IProps> = ({
  data,
  page,
  count,
  categories,
  path,
}) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const image: Image = useTypedSelector((state) => state.image);

  const handleClick = (href: string) => {
    router.push(href);
  };

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    event.preventDefault();
    router.push(`/gallery/${value}${path}`);
  };
  React.useEffect(() => {
    dispatch(loadImages(data));
    return function () {
      dispatch(cleanGallery());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const BoxImage = styled(Paper)(({ theme }) => ({
    width: '100%',
    height: 200,
    position: 'relative',
    borderRadius: theme.spacing(1),
    overflow: 'hidden',
    cursor: 'pointer',
    '&:hover': {
      boxShadow: '0 15px 25px 0 rgba(0,0,0,0.3)',
      backgroundSize: '10%',
    },
  }));

  return (
    <Box>
      <Container>
        {image.open && <GalleryImage />}
        <Grid container spacing={1} justifyContent="center" sx={{ my: 4 }}>
          <Grid item xs="auto">
            <Chip
              label={router.locale === 'fr' ? 'Voir tout' : 'See all'}
              variant="outlined"
              color={router.asPath.split('/')[3] ? 'default' : 'primary'}
              onClick={() => handleClick('/gallery/1')}
            />
          </Grid>
          {categories.map((el) => {
            if (el.slug !== 'videos') {
              return (
                <Grid item xs="auto" key={el._id}>
                  <Chip
                    label={el.name}
                    variant="outlined"
                    color={
                      router.asPath.split('/')[3] === el.slug
                        ? 'primary'
                        : 'default'
                    }
                    onClick={() => handleClick(`/gallery/1/${el.slug}`)}
                  />
                </Grid>
              );
            }
          })}
          {categories.map((el) => {
            if (el.slug === 'videos') {
              return (
                <Grid item xs="auto" key={el._id}>
                  <Chip
                    label={el.name}
                    variant="outlined"
                    color={
                      router.asPath.split('/')[3] === el.slug
                        ? 'primary'
                        : 'default'
                    }
                    onClick={() => handleClick(`/gallery/1/${el.slug}`)}
                  />
                </Grid>
              );
            }
          })}
        </Grid>

        <Grid container spacing={2} sx={{ my: 4 }}>
          {data.map((item, i) => (
            <Grid item key={i} xs={12} md={3}>
              <BoxImage
                elevation={0}
                onClick={() =>
                  dispatch(
                    showImage({
                      index: i,
                      open: true,
                      loading: true,
                      link:
                        item?.gallery_category?.slug === 'videos'
                          ? item.link
                          : API + item.media.url,
                      category:
                        item?.gallery_category?.slug === 'videos'
                          ? 'videos'
                          : '',
                    })
                  )
                }
              >
                {item?.gallery_category?.slug === 'videos' && (
                  <Stack
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                      position: 'absolute',
                      left: 10,
                      top: 10,
                      zIndex: 3,
                      borderRadius: 45,
                      background: '#ff000036',
                      width: 'auto',
                      height: 'auto',
                      p: 0.5,
                      boxShadow: '0 0 3px 5px #ff000014',
                    }}
                  >
                    <PlayCircleIcon fontSize="large" color="error" />
                  </Stack>
                )}
                <Image
                  src={
                    API +
                    (item.media.formats?.small?.url
                      ? item.media.formats?.small?.url
                      : item.media.url)
                  }
                  alt={item.media.alternativeText}
                  layout="fill"
                  objectFit="cover"
                  priority
                />
              </BoxImage>
            </Grid>
          ))}
        </Grid>
        <Stack alignItems="center" justifyContent="center" sx={{ my: 8 }}>
          <Pagination
            count={count}
            defaultPage={page}
            boundaryCount={1}
            siblingCount={1}
            shape="rounded"
            color="primary"
            onChange={handleChange}
          />
        </Stack>
      </Container>
    </Box>
  );
};

export default ImagesList;
